/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_LegalInputs */

const en_landing_footer_legal = /** @type {(inputs: Landing_Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const zh_landing_footer_legal = /** @type {(inputs: Landing_Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法律信息`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Landing_Footer_LegalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_legal = /** @type {((inputs?: Landing_Footer_LegalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_LegalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_legal(inputs)
	return zh_landing_footer_legal(inputs)
});
export { landing_footer_legal as "landing.footer.legal" }